var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[_c('b-card',{class:[
      'list-info-card px-3 py-3',
      { 'technician-info-card': _vm.dataObj.details && _vm.dataObj.details.assignedTechnicians && _vm.dataObj.details.assignedTechnicians.length > 0 }
    ],attrs:{"no-body":""}},[_c('div',{staticClass:"row"},[_c('infoData',{staticClass:"col-12 mt-2",attrs:{"data-obj":_vm.dataObj}}),_c('infoMetaData',{attrs:{"data-obj":_vm.dataObj}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }